import { render, staticRenderFns } from "./GiftMenuCard.vue?vue&type=template&id=5cfa0930"
import script from "./GiftMenuCard.vue?vue&type=script&lang=js"
export * from "./GiftMenuCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports